import { Playground } from 'docz';
import { Button, Buttons } from "../../../../../src/components/Button";
import Icons from "../../../../../src/components/Icons";
import * as React from 'react';
export default {
  Playground,
  Button,
  Buttons,
  Icons,
  React
};